import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function formatElapsed(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  if (h > 0) return `${pad(h)}:${pad(m)}:${pad(s)}`;
  return `${pad(m)}:${pad(s)}`;
}

interface TeleconsultCallTimerProps {
  startedAt: number | null;
  active?: boolean;
}

/** Contador de duração da chamada (desde o profissional entrar na sala Jitsi). */
const TeleconsultCallTimer: React.FC<TeleconsultCallTimerProps> = ({
  startedAt,
  active = true,
}) => {
  const [elapsedSec, setElapsedSec] = useState(0);

  useEffect(() => {
    if (!startedAt || !active) {
      setElapsedSec(0);
      return;
    }
    const tick = () => {
      setElapsedSec(Math.max(0, Math.floor((Date.now() - startedAt) / 1000)));
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [startedAt, active]);

  if (!startedAt) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: '#64748b' }}>
        <AccessTimeIcon sx={{ fontSize: 18 }} />
        <Typography variant="body2" sx={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
          Conectando…
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.5,
        borderRadius: 2,
        bgcolor: active ? '#f0fdfa' : '#f8fafc',
        border: '1px solid',
        borderColor: active ? '#99f6e4' : '#e2e8f0',
      }}
    >
      <AccessTimeIcon sx={{ fontSize: 18, color: '#0f766e' }} />
      <Typography
        variant="body2"
        sx={{ fontWeight: 700, color: '#0f766e', fontVariantNumeric: 'tabular-nums', letterSpacing: 0.5 }}
      >
        {formatElapsed(elapsedSec)}
      </Typography>
    </Box>
  );
};

export default TeleconsultCallTimer;
